import { useContext } from "react";
import { stateContext } from "../contexts/stateContext.js";
function useSelectState() {
  return useContext(stateContext);
}
export {
  useSelectState
};
//# sourceMappingURL=useSelectState.js.map
